import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IArticle,
  IArticleGetResponse,
} from '../types';
import {
  ARTICLES_GET_QUERY_KEY,
  ARTICLES_GET_URL,
  ARTICLES_LOCALE_ALL,
  ARTICLES_PERMISSIONS,
} from '../constants';

export default function useArticlesGetQuery(
  id: Ref<number>,
): IContextQueryResult<
    IArticleGetResponse,
    Error,
    IArticle
  > {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IArticleGetResponse,
    Error,
    IArticle
  >({
    queryKey: [ARTICLES_GET_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IArticleGetResponse>(
      ARTICLES_GET_URL,
      {
        signal,
        permission: ARTICLES_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => ({
      ...data.article,
      locale: !data.article.locale ? ARTICLES_LOCALE_ALL : data.article.locale,
    }),
    enabled: computed(() => !!id.value),
  });
}
